export const sendWhatsappMessage = (text: string, numberphone: string) => {
  const isWindows = navigator.userAgent.indexOf('Windows') !== -1;

  if (isWindows) {
    window.open(`https://wa.me/${numberphone}?text=${text}`, '_blank');
  } else {
    window.open(`whatsapp://send?text=${text}&phone=${numberphone}`, '_blank');
  }
};
